import { render } from "./terminationmodel.vue?vue&type=template&id=6268290d"
import script from "./terminationmodel.vue?vue&type=script&lang=js"
export * from "./terminationmodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__